/**
 * Fetches clients data from the API
 * @param {string} token - Authentication token
 * @param {string} apiUrl - Base API URL
 * @returns {Promise<Array>} Array of clients
 * @throws {Error} If the request fails
 */
export const fetchClients = async (token, apiUrl) => {
  if (!token) {
    throw new Error("Authentication token is required");
  }

  const response = await fetch(`${apiUrl}/api/v1/veterinaries/clients`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : data.clients || [];
};

/**
 * Fetches detailed information for a specific client
 * @param {string} token - Authentication token
 * @param {string} apiUrl - Base API URL
 * @param {string|number} clientId - Client ID
 * @returns {Promise<Object>} Client details including appointments
 * @throws {Error} If the request fails
 */
export const fetchClientDetails = async (token, apiUrl, clientId) => {
  if (!token || !clientId) {
    throw new Error("Token and client ID are required");
  }

  const response = await fetch(
    `${apiUrl}/api/v1/veterinaries/client_details/${clientId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};